import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import DeviceHelper from '../../helpers/device-helper';

const WhastsappFabButton = ({whatsapp, message}) => {
  const whatsappLinkPrefix = DeviceHelper.isMobile() ? `api` : `web`;
  const whatsappLink = `https://${whatsappLinkPrefix}.whatsapp.com/send?phone=${whatsapp}&text=${message}`;
  return <a href={whatsappLink} className="my-whatsapp-fab" target="_blank" rel="noopener noreferrer" alt={message}>
    <FontAwesomeIcon icon={faWhatsapp} className="my-whatsapp-fab-float" />
  </a>;
}
export default WhastsappFabButton;
